import React from 'react';
import { HeroSection } from '../components/HeroSection';
import { PillarCard } from '../components/PillarCard';
import { Button } from '../components/ui/Button';
import { BookOpen, Users, PenTool, Heart } from 'lucide-react';
export function Home() {
  return <div className="min-h-screen bg-brand-cream" data-id="element-2212">
      <HeroSection title="Fat Liberation Learning & Community" subtitle="ReGrowth is a digital space for political education, community building, and radical imagination rooted in fat justice." bgColor="navy" textColor="white" tag="Welcome to ReGrowth" data-id="element-2213" />

      {/* Pillars Grid */}
      <section className="py-20 px-4 sm:px-6 lg:px-8 max-w-7xl mx-auto -mt-20 relative z-20" data-id="element-2214">
        <div className="grid grid-cols-1 md:grid-cols-2 gap-8" data-id="element-2215">
          <PillarCard title="Fat Liberation & Justice" description="The ethical anchor and political framework of our work. Understand the systems of power, our lineage, and our commitments." path="/fat-liberation" color="magenta" icon={<Heart className="h-10 w-10 text-brand-magenta mb-4" data-id="element-2217" />} data-id="element-2216" />

          <PillarCard title="Learning & Growth" description="Courses, cohorts, and resources to deepen your political analysis and unlearn anti-fat bias. We don't just publish ideas—we support growth." path="/learning-growth" color="cyan" icon={<BookOpen className="h-10 w-10 text-brand-cyan mb-4" data-id="element-2219" />} data-id="element-2218" />

          <PillarCard title="The Digital Publication" description="A journal-like platform for essays, reporting, and art from fat creators. Intellectually rich, confident, and unapologetic." path="/publication" color="orange" icon={<PenTool className="h-10 w-10 text-brand-orange mb-4" data-id="element-2221" />} data-id="element-2220" />

          <PillarCard title="About ReGrowth" description="Who we are, how we work, and the principles that guide us. Transparency, accountability, and human grounding." path="/about" color="lime" icon={<Users className="h-10 w-10 text-brand-lime mb-4" data-id="element-2223" />} data-id="element-2222" />
        </div>
      </section>

      {/* Mission Statement */}
      <section className="py-24 bg-white" data-id="element-2224">
        <div className="max-w-4xl mx-auto px-4 text-center" data-id="element-2225">
          <h2 className="text-3xl md:text-5xl font-black uppercase mb-8 text-brand-black leading-tight" data-id="element-2226">
            We believe in a world where fat people are{' '}
            <span className="text-brand-magenta" data-id="element-2227">free</span>,{' '}
            <span className="text-brand-cyan" data-id="element-2228">respected</span>, and{' '}
            <span className="text-brand-orange" data-id="element-2229">powerful</span>.
          </h2>
          <p className="text-xl text-gray-600 mb-12 leading-relaxed max-w-2xl mx-auto" data-id="element-2230">
            ReGrowth exists to bridge the gap between academic theory and lived
            experience, creating accessible pathways to radicalization and
            community.
          </p>
          <Button color="navy" size="lg" withArrow data-id="element-2231">
            Join Our Community
          </Button>
        </div>
      </section>
    </div>;
}